import { useMutation } from "@tanstack/react-query";
import { AxiosHeaders } from "axios";
import { patch, post, del } from "../api/util";
interface IError {
  config: any;
  data: { StatusCode: number; Message: string; title: string };
  headers: AxiosHeaders;
  request: XMLHttpRequest;
  status: number;
  statusText: string;
}
export function useForm<U, V = U>(
  method: FormMethod,
  config: FormConfig<U, V>,
  onSuccess?: () => void,
) {
  const {
    isError,
    isPending: isSaving,
    mutate: submit,
    error,
    data,
  } = useMutation({
    onSuccess() {
      if (onSuccess) onSuccess();
    },
    mutationFn: (values: (U & V) | undefined = undefined) => {
      switch (method) {
        case "patch":
          if (!config.patch) throw new Error("Missing patch config");
          if (!values) throw new Error("no values passed");
          return patch(config.patch(values));
        case "post":
          if (!config.post) throw new Error("Missing post config");
          if (!values) throw new Error("no values passed");
          return post(config.post(values));
        case "delete":
          if (!config.delete) throw new Error("Missing delete config");
          const result = del(config.delete());
          if (config.afterDeleteFunction) config.afterDeleteFunction();
          return result;
      }
    },
  });
  return {
    isError,
    isSaving,
    submit,
    error: error as unknown as IError,
    data,
  };
}
